import { useSelector } from 'react-redux'

import { translate } from '@/utils/translations'

const Header = () => {
  const storeCurrency = useSelector(state => state.currentRegion.storeCurrency)

  return (
    <div className='related-assets__header'>
      <h2 className='related-assets__heading styled_as_body_font'>
        {translate('related_assets.other_items_need')}
      </h2>
      <div className='u-align--right u-weight--medium u-soft-half--right'>
        {storeCurrency}
      </div>
    </div>
  )
}

export default Header
